import { createRouter, createWebHistory } from 'vue-router';
import Common, { isMobilePlatform } from '@/utils/common';
import Qs from 'qs';

const envJudge = require('../utils/envJudge');

const routes = [
  /** mobile 端路由 */
  {
    path: '/iframe',
    name: 'iframe',
    component: () => import('@/components/iframe')
  },
  {
    path: '/m-login',
    name: 'mobileLogin',
    component: () => import('@/views/mobile/login')
  },
  {
    path: '/applogin',
    name: 'appLogin',
    component: () => import('@/views/app/login')
  },
  {
    path: '/security/accountSet',
    name: 'accountSet',
    component: () => import('@/views/mobile/accountSet')
  },
  {
    path: '/security/rebindPhone',
    name: 'rebindPhone',
    component: () => import('@/views/mobile/rebindPhone')
  },
  {
    path: '/security/modifyPwd',
    name: 'modifyPwd',
    component: () => import('@/views/mobile/modifyPwd')
  },
  {
    path: '/security/thirdPart',
    name: 'thirdPart',
    component: () => import('@/views/mobile/thirdPart')
  },
  {
    path: '/security/bindEmail',
    name: 'bindEmail',
    component: () => import('@/views/mobile/bindEmail')
  },
  {
    path: '/security/application',
    name: 'application',
    component: () => import('@/views/mobile/application')
  },
  {
    path: '/security/profile',
    name: 'profile',
    component: () => import('@/views/mobile/profile')
  },
  {
    path: '/security/nickName',
    name: 'nickName',
    component: () => import('@/views/mobile/nickName')
  },
  {
    path: '/security/loginDev',
    name: 'loginDev',
    component: () => import('@/views/mobile/loginDev')
  },
  {
    path: '/security/safeVerify',
    name: 'safeVerify',
    component: () => import('@/views/mobile/safeVerify')
  },

  /** web 端路由 */
  {
    path: '',
    redirect: '/security/security'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/web/login')
  },
  {
    path: '/huawei-login',
    name: 'huaweiLogin',
    component: () => import('@/views/web/huaweiLogin')
  },
  {
    path: '/account/userLogin/hwCallback',
    name: 'huaweiCallback',
    component: () => import('@/views/web/huaweiLogin')
  },
  {
    path: '/security',
    component: () => import('@/layout'),
    children: [
      {
        path: '/security/parent',
        name: 'keepAliveA',
        component: () => import('@/views/test/parent.vue')
      },
      // {
      //   path: '/security/b',
      //   name: 'keepAliveB',
      //   component: () => import('@/views/test/keep-alive-b')
      // },
      {
        path: 'userInfo',
        name: 'userInfo',
        component: () => import('@/views/web/userInfo')
      },
      {
        path: 'security',
        name: 'security',
        component: () => import('@/views/web/security/security')
      },
      {
        path: 'thirdAccount',
        name: 'thirdAccount',
        component: () => import('@/views/web/security/thirdAccount')
      },
      {
        path: 'appAuth',
        name: 'appAuth',
        component: () => import('@/views/web/appAuth')
      },
      {
        path: 'loginDevice',
        name: 'loginDevice',
        component: () => import('@/views/web/loginDevice')
      }
    ]
  }
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/login'
  // }
  // {
  //   path: '/about',
  //   name: 'About',
  //   route level code-splitting
  //   this generates a separate chunk (about.[hash].js) for this route
  //   which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
];

const router = createRouter({
  history: createWebHistory(envJudge()),
  routes
});

let handleKeepToken = false;
router.beforeEach(async function (to, from, next) {
  const toName = to.name;
  if (isMobilePlatform() && toName === 'accountSet') {
    next(); // next()调用了，则不会再次触发beforeEach方法
  }
  if (isMobilePlatform() && toName === 'appLogin') {
    next(); // next()调用了，则不会再次触发beforeEach方法
  }

  let searchObj = Qs.parse(location.search, { ignoreQueryPrefix: true });
  if (Common.getToken()) {
    console.log('before 有token: ', toName);
    if (searchObj.redirect) {
      if (searchObj.keepToken === '1' && !handleKeepToken) {
        handleKeepToken = true;
        next({ name: 'login', query: searchObj });
      } else {
        next();
        handleKeepToken = false;
      }
    } else {
      if (toName === 'mobileLogin') {
        next({name: 'accountSet'});
      } else if (toName === 'login') {
        next({name: 'security'});
      } else if (toName === 'huaweiLogin' || toName === 'huaweiCallback') {
        // 华为登录页面，即使已登录也允许访问（用于重新绑定或切换账号）
        console.log('已登录用户访问华为登录页: ', toName);
        next();
      } else {
        console.log('进入 next: ', toName);
        next();
      }
    }
  } else {
    console.log('before 没token: ', toName);
    if (['login', 'mobileLogin', 'iframe', 'huaweiLogin', 'huaweiCallback'].some(item => item === toName)) {
      console.log(' 没token 进入next: ', toName);
      next();
    } else if (isMobilePlatform()) {
      next({name: 'mobileLogin'});
    } else {
      if (Object.keys(searchObj).length) { // 防止location.search参数丢失
        next({ name: 'login', query: searchObj });
      } else {
        next({ name: 'login' });
      }
    }
  }
});

export default router;
